import { Component, OnInit, inject } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Permission } from 'src/app/common/enums/permissions';
import { AuthService } from 'src/app/core/authentication/auth.service';
import { WorkerProfileAccessService } from 'src/app/data/worker-profile-access.service';

@Component({
  selector: 'app-successfully-finished-questionnaire',
  templateUrl: './successfully-finished-questionnaire.component.html',
  styleUrls: ['./successfully-finished-questionnaire.component.scss'],
  standalone: false
})
export class SuccessfullyFinishedQuestionnaireComponent implements OnInit {
  private route = inject(ActivatedRoute);
  private authService = inject(AuthService);
  private workerProfileAccessService = inject(WorkerProfileAccessService);

  workerId: number;
  agreementId: number;
  employmentTypeId: number;
  isLoggedUserProfile: boolean;

  constructor() { }

  ngOnInit(): void {
    this.workerId = this.route.snapshot.queryParams.workerId;
    this.agreementId = this.route.snapshot.queryParams.agreementId;
    this.employmentTypeId = this.route.snapshot.queryParams.employmentTypeId;
    this.workerProfileAccessService.isLoggedUserProfile$.subscribe((value) => (this.isLoggedUserProfile = value))
  }

  isCoordinator() {
    return this.authService.hasPermission(Permission.ManageMyExternalWorkersList);
  }
}
